import React, { Fragment } from 'react'
import Footer from '../../component/Other/Footer'
import Navbar from '../../component/Other/Navbar'
import Contact from '../../component/Section/Contact'
import Head from '../../component/Section/Head'


const Terms = () => {
    const projects = [
        {
            title: "Bursa Büyükşehir Belediyesi",
            category: [],
            link: "https://www.bursa.bel.tr/",
            bg: "./../images/project/Image.png"
        },
        {
            title: "Eczacıbaşı",
            category: [],
            link: "https://www.eczacibasi.com.tr/tr/anasayfa",
            bg: "./../images/project/Image-1.png"
        },
        {
            title: "Çanakkale Onsekiz Mart Üniversitesi",
            category: [],
            link: "https://www.comu.edu.tr/",
            bg: "./../images/project/Image-2.png"
        },
        {
            title: "Karayolları Genel Müdürlüğü",
            category: [],
            link: "https://www.kgm.gov.tr/Sayfalar/KGM/SiteTr/Root/default.aspx",
            bg: "./../images/project/Image-3.png"
        },
        {
            title: "İstanbul Büyükşehir Belediyesi",
            category: [],
            link: "https://www.ibb.istanbul/",
            bg: "./../images/project/Image-4.png"
        },
        {
            title: "T.C. Silivri Belediyesi",
            category: [],
            link: "https://www.silivri.bel.tr/",
            bg: "./../images/project/Image-5.png"
        },
        
    ]
    return (
        <Fragment>
            <div className="overflow-hidden">
                <div className="position-relative">
                    <img src="./../images/Bg.png" className="images__wrap-head" alt="" />
                    <div className="wrapper__bg-head"></div>
                    <Navbar />
                    <Head default="" current="" title={"Referanslarımız"} />
                </div>

                <section>
                    <div className="container">
                        

                        

                        
                        <div className="row">
                            {
                                projects.map((obj) => {
                                    return <div className="col-md-4 mb-4">
                                        <div className="wrapper__card-image-project position-relative">
                                            <img src={obj.bg} className='bg' alt="" />
                                            <div className="cover"></div>
                                            <div className="desc text-center color__white">
                                                <h4 className='bold font__size--20 text__20-1024 text-uppercase mb-0'>{obj.title}</h4>
                                                <div className="category my-3">
                                                    {
                                                        obj.category.map((i) => {
                                                            return <div className="items bold font__size--12 text__12-1024 roboto">
                                                                {i}
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                                <a href={obj.link} className='normal color__white font__size--20 text__20-1024 text-uppercase'>Git</a>
                                            </div>
                                        </div>
                                    </div>
                                })
                            }

                        </div>

                        
                    </div>
                </section>

                <Contact />

                <Footer />
            </div >
        </Fragment>
    )
}

export default Terms